import React, { useRef, useEffect } from 'react';
import './App.css';
import 'primereact/resources/primereact.css';
// import 'primereact/resources/themes/lara-light-indigo/theme.css'; // used
import 'primereact/resources/themes/saga-green/theme.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './print.css';
import { addLocale } from 'primereact/api';
import getSdk, { ApplicationSdk } from './stores';
import {
  observer
} from 'mobx-react-lite';
import AuthView from './pages/AuthView';
import CleanerView from './pages/CleanerView';
import ManagerView from './pages/ManagerView';
import DialogView from './dialogs/DialogView';
import { Toast } from 'primereact/toast';
import DeleteConfirmationDialog from './dialogs/components/DeleteConfirmation';
import DocumentView from './pages/DocumentView';

addLocale('de', {
  firstDayOfWeek: 1,
  dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
  dayNamesShort: [ 'Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
  dayNamesMin: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
  monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
  monthNamesShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
  today: 'Heute',
  clear: 'Löschen'
});

const App = observer(() => {
  const toast = useRef<Toast>(null);
  const sdk: ApplicationSdk = getSdk();

  const showToast = (toaster: any) => {
    toast.current?.show({
      ...toaster,
      detail: <div style={{ whiteSpace: 'pre-line' }}>{toaster.message}</div>
    });
  };

  useEffect(() => {
    sdk.registerToastCallback(showToast);
  }, [sdk]);

  return (
    <div className="App">
      {sdk.locationEntity === 'auth' ? <AuthView sdk={sdk} /> : null}
      {sdk.locationEntity === 'cleaner' ? <CleanerView sdk={sdk} /> : null}
      {sdk.locationEntity === 'signabledocuments' ? <DocumentView sdk={sdk} /> : null}
      {sdk.locationEntity === 'edit' ? <ManagerView sdk={sdk} /> : null}
      {sdk.currentDialog ? <DialogView sdk={sdk} /> : null}
      {sdk.currentConfirmation && <DeleteConfirmationDialog sdk={sdk}  data={sdk.currentConfirmation} />}
      <Toast ref={toast} />
    </div>
  );
});

export default App;